// Single source of truth for category colors.
// Three-accent rotation matching the brand: red / teal / gold.
//
// Replaces six duplicate definitions of CAT_DARK / ART_CAT /
// CATEGORY_COLORS / CAT_COLORS that drifted across HomePage,
// EventsPage, MagazinePage, EventCard, ArticleCard.

const RED   = { color: '#E63946', bg: 'rgba(230,57,70,0.12)',  border: 'rgba(230,57,70,0.25)'  };
const TEAL  = { color: '#12B886', bg: 'rgba(18,184,134,0.12)', border: 'rgba(18,184,134,0.26)' };
const GOLD  = { color: '#E9C061', bg: 'rgba(233,162,59,0.13)', border: 'rgba(233,162,59,0.26)' };
const CLAY  = { color: '#C2673F', bg: 'rgba(194,103,63,0.13)', border: 'rgba(194,103,63,0.26)' };

const DEFAULT_EVENT = RED;
const DEFAULT_ARTICLE = { color: 'rgba(251,244,230,0.62)', bg: 'rgba(251,244,230,0.07)' };

// Event categories — all keys lowercase
export const EVENT_CATEGORIES = {
  music:      RED,
  nightlife:  TEAL,
  food:       CLAY,
  culture:    GOLD,
  art:        CLAY,
  arts:       CLAY,
  fashion:    RED,
  sports:     TEAL,
  business:   GOLD,
  community:  GOLD,
  online:     TEAL,
  comedy:     RED,
  networking: GOLD,
  education:  TEAL,
  film:       RED,
  theater:    CLAY,
  dance:      RED,
  technology: TEAL,
  health:     TEAL,
  religion:   GOLD,
  politics:   GOLD,
  travel:     CLAY,
  other:      RED,
};

// Article (magazine) categories — slug keys
export const ARTICLE_CATEGORIES = {
  'event-spotlight':  RED,
  'african-business': GOLD,
  'whos-building':    TEAL,
  'culture':          GOLD,
  'music':            RED,
  'food':             GOLD,
  'community':        TEAL,
  'video':            RED,
  'artist-spotlight': RED,
  'event-highlight':  RED,
  'news':             TEAL,
  'travel':           TEAL,
  'fashion':          RED,
};

// Normalize "Artist Spotlight" → "artist-spotlight" so we match keys
// regardless of whether the consumer passes a slug or a display name.
function normalize(s) {
  return String(s).toLowerCase().trim().replace(/\s+/g, '-');
}

export function getEventCategory(name) {
  if (!name) return DEFAULT_EVENT;
  return EVENT_CATEGORIES[normalize(name)] || DEFAULT_EVENT;
}

export function getArticleCategory(slug) {
  if (!slug) return DEFAULT_ARTICLE;
  return ARTICLE_CATEGORIES[normalize(slug)] || DEFAULT_ARTICLE;
}
